import React from "react";
import useCookie from "@lib/use-cookie";
import { setPageStatus } from "../redux/slices/navSlice";
import { logOutUser } from "../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { signOut } from "../services/auth";
import { useSelector } from "react-redux";
import withEventsLogger from "@/events/withEventsLogger";
import useDeviceId from "@/events/useDeviceId";
import useSessionId from "@/events/useSessionId";

const LoggedInAs = ({ user, logEvents }) => {
  const deviceId = useDeviceId();
  const sessionId = useSessionId();
  const company = useSelector((state) => state.company);
  const pageStatus = useSelector((state) => state.nav.pageStatus);
  const dispatch = useDispatch();
  const [cookie, updateCookie] = useCookie("userToken", null);
  async function logOut() {
    if (pageStatus === "payment") {
      dispatch(setPageStatus("gift_page_2"));
    }
    dispatch(logOutUser());
    updateCookie("", -365);
    await signOut();
  }
  const handleAmplitude = (eventName, eventProperties = {}) => {
    logEvents([
      {
        session_id: sessionId,
        event_name: eventName,
        device_id: deviceId,
        event_properties: {
          ...eventProperties,
        },
      },
    ]);
  };

  return (
    user && (
      <div className="signed-in-as">
        <div className="checkout-head">You're currently signed in</div>
        <div className="inner">
          <div className="wrapper">
            <div className="user-grid">
              {user.profile_picture ? (
                <img
                  src={`${company.presenter.cloudinary_path}/h_80,w_80,c_fill/${user.profile_picture.path}`}
                  className="prof-pic"
                  alt={user.first_name ? user.first_name.split("")[0] : ""}
                />
              ) : (
                <div className="initial font-bold">
                  {(user.first_name || user.email).split("")[0].toUpperCase()}
                </div>
              )}
              <div className="info-col">
                <div className="inner-col">
                  <span className="font-bold">
                    {user.first_name} {user.last_name}
                  </span>
                  <span>{user.email}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="not-you">
            Not you?{" "}
            <button onClick={logOut} type="button">
              Log out
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default withEventsLogger(LoggedInAs);
